import {ComponentDataModel} from "@utils/Models";
import {ApiUrl_Components_GetByName, ApiUrl_Components_GetByNameAndSeriesId} from "@utils/Endpoints";
import FlintRemoteDataComboBox from "@components/controls/FlintRemoteDataComboBox";
import {useTranslation} from "react-i18next";
import {FlintValidationData} from "@utils/AppConstants";

export default function InkSeriesComponentPicker(props: InkSeriesComponentPickerProps) {
    const {t} = useTranslation();
    const {required = true, placeHolder = t("COMMON_ComponentCode"), componentName, onItemSelected, validationData, disabled, seriesId, ignoreSeriesFilter, maxLength} = props;
    const useSeriesEndpoint = !ignoreSeriesFilter && seriesId != null && seriesId > 0;
    return (
        <FlintRemoteDataComboBox<ComponentDataModel>
            required={required}
            placeholder={placeHolder}
            defaultValue={{Name: componentName}}
            baseUrl={useSeriesEndpoint ? ApiUrl_Components_GetByNameAndSeriesId : ApiUrl_Components_GetByName}
            filterParamName={useSeriesEndpoint ? "txtFilter" : "filter"}
            parameters={useSeriesEndpoint ? {seriesId} : undefined}
            minFilterLength={2}
            validationData={validationData}
            disabled={disabled}
            maxLength={maxLength}
            onItemSelected={(r) => onItemSelected(r)}
        />
    )
}

export interface InkSeriesComponentPickerProps {
    componentName: string | null;
    onItemSelected: (value: ComponentDataModel) => void;
    required?: boolean;
    placeHolder?: string;
    validationData?: FlintValidationData;
    disabled?: boolean;
    seriesId?: number;
    /** When true, always searches the full database regardless of seriesId. */
    ignoreSeriesFilter?: boolean;
    maxLength?: number;
}
